<template>
<div>
  <div class="field-input-radio">
    <div>
        <label
            v-html="fieldData.label"
            :for="fieldData.field_name"
            :class="(isRequired ? 'field-required' : '')">
        </label>
    <!-- <label>Vendor Status<span class='star'>*</span></label> -->
    </div>
    <div class="input-group">
      <div :aria-describedby="`${fieldData.field_name}_describedby`" class="btn-group btn-group-toggle" data-toggle="buttons" role="radiogroup"  :aria-labelledby="fieldData.field_name"
        :class="{ 'locked': (!fieldData.is_enabled || (!!showDisabled())), 'error': errors.has(fieldData.field_name) || fieldData.has_error }">
        <div v-for="(subItem, sKey) in fieldData.values" :key="sKey"
          class="btn-group-inner-div"
          v-bind:class="{'btn btn-outline-light': true,
          'active': (fieldData.field_value === subItem.internal_value)}"
          @click.prevent="setSwitchValue(fieldData, subItem.internal_value, $event)">
          <template v-if="subItem.visible && sKey == 0">
            <input
              :disabled="(!!showDisabled())"
              :ref="fieldData.field_name"
              :name="fieldData.field_name + '_radio_option'"
              :id="fieldData.field_name + '_radio_option_' + sKey"
              type="radio"
              class="radio-input-field"
              :value="subItem.internal_value"><label :for="fieldData.field_name + '_radio_option_' + sKey">{{ subItem.display_value }}</label>
          </template>
          <template v-else-if="subItem.visible">
            <input
              :disabled="(!!showDisabled())"
              :ref="fieldData.field_name"
              :name="fieldData.field_name + '_radio_option'"
              :id="fieldData.field_name + '_radio_option_' + sKey"
              type="radio"
              class="radio-input-field"
              :value="subItem.internal_value"><label :for="fieldData.field_name + '_radio_option_' + sKey">{{ subItem.display_value }}</label>
          </template>
        </div><div><span v-bind:class="{'warning fas fa-exclamation-triangle': errors.has(fieldData.field_name)  || fieldData.has_error }"></span></div>
        <input
          :disabled="(!!showDisabled())"
          v-show="false"
          :name="fieldData.field_name"
          :id="fieldData.field_name"
          type="text"
          @blur="postRule($event.target.value, fieldData)"
          class="form-control"
          :maxlength="fieldData.max_length"
          v-model="fieldData.field_value"
          v-validate="fieldData.rules">
      </div>
    </div>
  </div>
 </div>
</template>

<script>
/* eslint-disable */ 
/* eslint prefer-const: */
/* eslint no-undef:  */
/* eslint consistent-return:  */
//import { inputFieldMixin } from '../../../mixins/inputFieldMixin';
/* eslint-disable */ 
export default {
  inject: ['$validator'], // Allows this component's validation messages to appear in other components
  props: ['fieldData', 'inputType', 'sendPostRule'],
  computed: {
    isRequired() {
      return this.fieldData.rules && this.fieldData.rules.required === true;
    },
  },
  methods: { 
    showDisabled() {
      return !this.fieldData.is_enabled;
    },
    getAnswerOption(type) {
      if (type === 'display') {
        return this.fieldData.values[0].display_value;
      } else if (type === 'internal') {
        return this.fieldData.values[0].internal_value;
      }
    },
    setSwitchValue(formData, switchVal) {
      if (formData.is_enabled) {
        const switchId = formData.field_name;
        if (document.getElementById(switchId).value === switchVal) {
          // this.$validator.validate(switchId);
          return;
        }
        document.getElementById(switchId).value = switchVal;
        this.fieldData.field_value = switchVal;
      }
    },
  },
};
</script>

<style scoped lang="scss">
/*
  TODO: Add IE/Edge support by implementing the `label.btn` styles via JavaScript. Bootstrap adds classes
  'focus' and 'active' to the radio <input>'s "closest" element, which happens to be the <label>.
  See https://github.com/twbs/bootstrap/blob/7c7a1706c348fcb5290a63d9249e0c8e4b6ebbcf/js/src/button.js#L153 .
*/
label.btn:focus-within {
  color: #fff;
  background-color: #001a33;
  border-color: #001326;
  z-index: 1;
  -webkit-box-shadow: 0 0 0 0.2rem rgba(0, 51, 102, 0.5);
  box-shadow: 0 0 0 0.2rem rgba(0, 51, 102, 0.5);
  -webkit-box-shadow: 0 0 0 0.2rem rgba(0, 51, 102, 0.5);
  box-shadow: 0 0 0 0.2rem rgba(0, 51, 102, 0.5);
}
.btn-outline-light {
/**NEW-TOM: Update color, border-color**/
  color: #333333;
  background-color: #FFFFFF;
  border-color: #CCCCCC;
}
.btn-outline-light:hover {
/**NEW-TOM: Update color, background-color, border-color**/
  background-color: #EEEEEE;
}

.btn-outline-light:not(:disabled):not(.disabled):active,
.btn-outline-light:not(:disabled):not(.disabled).active,
.show > .btn-outline-light.dropdown-toggle {
/**NEW-TOM: Update color, background-color, border-color**/
  color: #FFFFFF;
  background-color: $var-qs-dark-blue;
  border-color:$var-qs-dark-blue;
}

.btn-group.btn-group-toggle .btn {
    padding: 0.185rem .5rem 0;
    min-width: 4.5rem;
}
label {
    display: inline-block;
    margin-bottom: 0.125rem;
    font-size: 0.75rem;
    line-height: 1.25rem;
}
.vin-label {
  color:#003766;
  font-weight: bold;
}
.vin-num{
  color: #333333;
}
.field-input-radio .btn-group-toggle:focus-within{
  color: #5c6873;
  border-color: #8ad4ee;
  outline: 0;
  -webkit-box-shadow: 0 0 0 0.2rem rgba(32, 168, 216, 0.25);
  box-shadow: 0 0 0 0.2rem rgba(32, 168, 216, 0.25);
  border-radius: 0.25rem !important;
}
.field-container.pr-2 .field-input-radio .input-group .btn-group > .btn-group-inner-div.btn.btn-outline-light:nth-last-child(3n) {
  border-top-right-radius: 0.25rem !important;
  border-bottom-right-radius: 0.25rem !important;
}.field-input-radio .input-group .btn-group > .btn-group-inner-div.btn.btn-outline-light:not(:last-child) {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/interactive/InputRadioButton.vue?7c607e28